import { Box, BoxProps } from '@mui/material';

interface FlexProps {
  children: React.ReactNode;
  center?: boolean;
  between?: boolean;
  column?: boolean;
}

export const Flex = (props: FlexProps & BoxProps) => {
  const { children, center, between, column, ...rest } = props;

  return (
    <Box
      display="flex"
      flexDirection={column ? 'column' : 'row'}
      justifyContent={
        between ? 'space-between' : center ? 'center' : 'flex-start'
      }
      alignItems={center ? 'center' : 'flex-start'}
      {...rest}
    >
      {children}
    </Box>
  );
};
